import { render, staticRenderFns } from "./DialogRecarga.vue?vue&type=template&id=636a272a&"
import script from "./DialogRecarga.vue?vue&type=script&lang=js&"
export * from "./DialogRecarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports